/* eslint-disable */ /* disabled for Hot Loader */

import Promise from 'bluebird';
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

//allows async await

// Want to make sure we load in our polyfills before starting the
// rest of our app in case we are referencing polyfilled methods
import '../shared/Polyfills';

import reducer from '../shared/Reducer';
import { setReduxStore as setLogReduxStore } from '../shared/utils/log';
import { setReduxStore as setVerbFetchReduxStore } from '../shared/VerbFetch';
import Root from './containers/Root';
import setupSession from './SessionSetup';

// Turning off warnings because #yolo
Promise.config({
    warnings: false
});

// We reference a redux dev tool global to set up redux dev tools
// if the user has the browser extension resolved
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const middleware = [thunk];
const store = createStore(reducer, {}, composeEnhancers(applyMiddleware(...middleware)));

// This allows us to use data in the state for our default fetch
setVerbFetchReduxStore(store);
setLogReduxStore(store);
setupSession(store);

const MainContentAdminComponent = () => <Root store={store} />;

export default MainContentAdminComponent;
